import { render, staticRenderFns } from "./JamalFabricReport.vue?vue&type=template&id=c334983a&scoped=true&"
import script from "./JamalFabricReport.vue?vue&type=script&lang=js&"
export * from "./JamalFabricReport.vue?vue&type=script&lang=js&"
import style0 from "./JamalFabricReport.vue?vue&type=style&index=0&id=c334983a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c334983a",
  null
  
)

export default component.exports